import React from 'react';

export const Users: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M10 12.6667V12.3333C10 11.0447 8.95533 10 7.66667 10H4.33333C3.04467 10 2 11.0447 2 12.3333V12.6667"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="6.00033"
      cy="4.99984"
      r="2.33333"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6667 12.6667V12.3333C14.6667 11.0447 13.622 10 12.3333 10H12"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.667 2.6665C11.9557 2.6665 13.0003 3.71117 13.0003 4.99984C13.0003 6.2885 11.9557 7.33317 10.667 7.33317"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
